import { when } from '@execonline-inc/maybe-adapter';
import { LinkIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { NavLink } from 'react-router-dom';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import { T } from '../../../../Translations';
import InviteIcon from '../../../Cutesies/InviteIcon';
import ShareableLinkIcon from '../../../Cutesies/ShareableLinkIcon';
import NotSelectedInviteIcon from '../../../Cutesies/NotSelectedInviteIcon';

export interface Props {
  id: number;
}

const styles = [
  'flex items-center mr-10 lg:pb-2 block py-3.5 px-5 lg:py-0 lg:px-0 ',
  'lg:text-base text-lg font-medium cursor-pointer',
];
const activeStyle = 'border-b-2 lg:cursor-teal-600 lg:border-solid border-teal-600 text-teal-600';

function Nav({ id }: Props) {
  return (
    <div className="flex pt-8">
      {findLink('learning-collection-invitations', currentUserStore.links)
        .map(() => (
          <NavLink
            key="Invited Participants"
            to={`/learning_collections/${id}/invitations`}
            className={({ isActive }) =>
              clsx(styles, when(isActive, activeStyle).getOrElseValue(''))
            }
          >
            {({ isActive }) =>
              when(isActive, {})
                .map(() => (
                  <>
                    <InviteIcon className={'mr-2 h-5'} />
                    <T kind="Invited Participants" />
                  </>
                ))
                .getOrElse(() => (
                  <>
                    <NotSelectedInviteIcon className={'mr-2 h-5'} />
                    <T kind="Invited Participants" />
                  </>
                ))
            }
          </NavLink>
        ))
        .getOrElse(emptyFragment)}
      {findLink('program-deep-link', currentUserStore.links)
        .map(() => (
          <NavLink
            key="Program Access"
            to={`/learning_collections/${id}/deep-links`}
            className={({ isActive }) =>
              clsx(styles, when(isActive, activeStyle).getOrElseValue(''))
            }
          >
            {/* DVLP-7041: same tab, the page it opens follows the privilege. */}
            {findLink('learning-collection-deep-links', currentUserStore.links)
              .map(() => (
                <span className="flex items-center" data-intercom-target="shareable-links-tab-link">
                  <ShareableLinkIcon className="mr-2 h-5 fill-current" />
                  <T kind="Shareable Links" />
                </span>
              ))
              .getOrElse(() => (
                <>
                  <LinkIcon className="mr-2 h-5" />
                  <T kind="Program Access" />
                </>
              ))}
          </NavLink>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(Nav);
